"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("./comments"), exports);



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/resources/bugs/comments/index.js
// module id = 415
// module chunks = 0